// Task action types
export const TASK_GET_ALL = "TASK_GET_ALL";
export const TASK_SET_FILTERS = "TASK_SET_FILTERS";
export const TASK_CLEAR_FILTERS = "TASK_CLEAR_FILTERS";
export const TASK_SET_STATE = "TASK_SET_STATE";
export const TASK_PAGE_RESET = "TASK_PAGE_RESET";
export const TASK_SET_LOADING = "TASK_SET_LOADING";
export const TASK_SET_ERROR = "TASK_SET_ERROR";
export const TASK_CREATE = "TASK_CREATE";
export const TASK_CREATE_SUCCESS = "TASK_CREATE_SUCCESS";
export const TASK_CREATE_FAILURE = "TASK_CREATE_FAILURE";
export const TASK_UPDATE = "TASK_UPDATE";
export const TASK_UPDATE_SUCCESS = "TASK_UPDATE_SUCCESS";
export const TASK_UPDATE_FAILURE = "TASK_UPDATE_FAILURE";
export const TASK_DELETE = "TASK_DELETE";
export const TASK_DELETE_SUCCESS = "TASK_DELETE_SUCCESS";
export const TASK_DELETE_FAILURE = "TASK_DELETE_FAILURE";
export const TASK_GET_STATISTICS = "TASK_GET_STATISTICS";
export const TASK_SET_SELECTED_TASK = "TASK_SET_SELECTED_TASK";
export const TASK_SET_EMPLOYEES = 'TASK_SET_EMPLOYEES'; // Add this
// WorkLogAction.ts
export const CREATE_WORK_LOG_REQUEST = 'CREATE_WORK_LOG_REQUEST'
export const CREATE_WORK_LOG_SUCCESS = 'CREATE_WORK_LOG_SUCCESS'
export const CREATE_WORK_LOG_FAILURE = 'CREATE_WORK_LOG_FAILURE'